import { hide, show } from "slidetoggle";
import { Breakpoints } from "../../breakpoints";
import { slideToggleDefaults } from "../modules/_SlideToggle";

const siteHeaderSlideToggleDefaults = {
  ...slideToggleDefaults,
  onAnimationEnd: (e) => {
    // console.log(e);
    if (e.dataset.slideToggle == 'hidden') {
      e.removeAttribute('style');
    }
  }
}

class SiteHeader extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", () => {
      this.init();
    });
  }

  init() {
    const hoverMenuItems = this.querySelectorAll('.menu-main__item--lvl-0 > a');
    const menuButtons = this.querySelectorAll('.menu-main button');
    const menuBackButtons = this.querySelectorAll('.menu-main__back-button');
    const menuLines = this.querySelectorAll('.menu-main__item--lvl-0.menu-main__item--has-children');
    const desktopMenu = window.matchMedia(`(min-width: ${Breakpoints.header + 1}px)`);

    // Hover functionality desktop
    hoverMenuItems.forEach((item) => {
      const linkParent = item.parentElement;
      const hasSubMenu = linkParent.classList.contains('menu-main__item--has-children')
      const subMenu = linkParent.querySelector('.menu-main__container--lvl-1');
      const triggerButton = linkParent.querySelector('button');
      const parentMenuContainer = item.closest('.menu-main__container');
      const otherSubMenus = [...parentMenuContainer.querySelectorAll('.menu-main__container--lvl-1')].filter(otherSubMenu => otherSubMenu != subMenu);

      const removeOtherLinkFocusWithin = () => null;
      // this.querySelectorAll('.menu-item > a.is-hover-within')
      //   .forEach(otherLink =>
      //     otherLink.classList.remove('is-hover-within'));

      const closeOtherMenuItems = () => {
        otherSubMenus.map(otherSubMenu => {
          if (!otherSubMenu.contains(document.activeElement)) {
            removeOtherLinkFocusWithin();
            hide(otherSubMenu, siteHeaderSlideToggleDefaults)
          }
        });
      }

      const opeMenuItem = (e) => {
        if (!desktopMenu.matches) return;
        closeOtherMenuItems();
        if (hasSubMenu) {
          removeOtherLinkFocusWithin();
          item.classList.add('is-hover-within');
          show(subMenu, siteHeaderSlideToggleDefaults)
          parentMenuContainer?.classList.add('sub-open');
          triggerButton.classList.add('open');

        }
      };

      const closeMenuItem = (e) => {
        if (!desktopMenu.matches) return;
        if (hasSubMenu) {
          item.classList.remove('is-hover-within');
          hide(subMenu, siteHeaderSlideToggleDefaults)
          parentMenuContainer?.classList.remove('sub-open');
          triggerButton.classList.remove('open');
        }
      };


      linkParent.addEventListener('mouseenter', opeMenuItem);
      item.addEventListener('focus', opeMenuItem);

      linkParent.addEventListener('mouseleave', closeMenuItem);
      // item.addEventListener('blur', closeMenuItem);
    });

    // Click functionality mobile
    // 1. Expand/collapse submenu when clicking anywhere on the menu line except the text link
    menuLines.forEach((line) => {
      line.addEventListener('click', (e) => {
        if (desktopMenu.matches) return;
        // If the click is on the link, let it proceed (open page immediately)
        if (e.target.closest('a')) return;
        e.preventDefault();
        const button = line.querySelector('button');
        const subMenu = button?.nextElementSibling;
        if (subMenu) {
          this.slideMenuIn(subMenu, true);
          subMenu.querySelector('a, button')?.focus();
        }
      });
    });

    // 2. Keep chevron button click for accessibility (optional, can be removed if redundant)
    menuButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        if (desktopMenu.matches) return;
        e.preventDefault();
        const subMenu = button.nextElementSibling;
        if (subMenu) {
          this.slideMenuIn(subMenu, true);
          subMenu.querySelector('a, button')?.focus();
        }
      });
    });

    // Back buttons
    menuBackButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if (desktopMenu.matches) return;

        this.slideMenuIn(button.closest('.menu-main__container--lvl-1'), false);
        // .classList.remove('js-open');

        // Focus on first parent button
        button.closest('.menu-main__item--lvl-0')
          .querySelector('button')
          .focus();
      });
    });
  }

  closeAllMobileSubMenu() {
    this.querySelectorAll('.menu-main__container--lvl-1').forEach(menu => {
      this.slideMenuIn(menu, false);
    });
  }

  showMobileMenu(open = true) {
    const menuContainer = document.querySelector('.region-header');
    this.slideMenuIn(menuContainer, open);
  }

  slideMenuIn(menu, open = true) {
    const delay = 100; // Delays needed so animation can work

    if (open) {
      menu.classList.remove('max-header:!hidden');
      menu.classList.add('max-header:!block');
      setTimeout(() => {
        menu.classList.remove('max-header:!left-full')
        menu.classList.add('max-header:!left-0');
      }, delay);
    }
    else {
      menu.classList.remove('max-header:!left-0')
      menu.classList.add('max-header:!left-full')
      setTimeout(() => {
        menu.classList.add('max-header:!hidden');
        menu.classList.remove('max-header:!block');
      }, 300); // Duration has to match transition speed
    }
  }

  openSubMenuItem(item) {
    this.slideMenuIn()
  }
}

if (!customElements.get('site-header')) {
  customElements.define('site-header', SiteHeader);
}
